window.DirectDebitGuaranteeForm = (function() {
    window.dataLayer = window.dataLayer || [];
    let self = {
        elements: {
            messages: {
                invalidCheckboxError: '#direct-debit-invalid-error',
            },
            checkBox: {
                confirmCheck: '#direct-debit-checkbox',
            },
            button: {
                updateDetails: '#direct-debit-update',
            }
        },
        urls: {
            sendFormData: '/api/sitecore/UpdatePremiumBankDetails/SendBankDetails',
            requestSubmittedPageUrl: '/my-account/security/direct-debit-guarantee/request-submitted',
            errorPageUrl: '/error/error-page',
            removeBankDetailSession:'/api/sitecore/UpdatePremiumBankDetails/RemoveBankDetailSession'
        },
        css: {
            InvalidCheckbox: 'vds-checkbox--invalid',
            ConfirmCheckContainer: '#direct-debit-check-container'
        },
        statusDescription: {
            accepted: 'accepted'
        },
        func: {
            init: function () {
                self.func.bindings();
                $(self.elements.messages.invalidCheckboxError).hide();
                $(self.css.ConfirmCheckContainer).removeClass(self.css.InvalidCheckbox);
            },
            bindings: function () {
                $(self.elements.checkBox.confirmCheck).on('change', self.func.validateCheckbox);
                $(self.elements.button.updateDetails).on('click', self.func.handleContinue);
            },
            handleContinue: function (event) {
                event.preventDefault();
                if (self.func.handleCheckbox()) {
                    self.func.submitFormData();
                }
            },
            handleCheckbox: function () {
                if ($(self.elements.checkBox.confirmCheck).is(':checked')) {
                    $(self.elements.messages.invalidCheckboxError).hide();
                    $(self.css.ConfirmCheckContainer).removeClass(self.css.InvalidCheckbox);
                    return true;
                } else {
                    $(self.elements.messages.invalidCheckboxError).show();
                    $(self.css.ConfirmCheckContainer).addClass(self.css.InvalidCheckbox);
                    return false;
                }
            },
            validateCheckbox: function () {
                if ($(self.elements.checkBox.confirmCheck).is(':checked')) {
                    $(self.elements.messages.invalidCheckboxError).hide();
                    $(self.css.ConfirmCheckContainer).removeClass(self.css.InvalidCheckbox);
                }
            },
            submitFormData: function() {
                $.ajax({
                    type: 'PATCH',
                    url: self.urls.sendFormData,
                    data: {},
                    success: function(response) {
                        if (response.statusCode.toLowerCase() === self.statusDescription.accepted) {
                            window.location.href = self.urls.requestSubmittedPageUrl;
                        }
                        else {
                            window.location.href = self.urls.errorPageUrl;
                        }
                    },
                    error: function() {
                        window.location.href = self.urls.errorPageUrl;
                    }
                });
            },
            removeBankDetailSession: function () {
                $.post(self.urls.removeBankDetailSession)
                    .done(function () {
                        window.location.href = self.urls.requestSubmittedPageUrl;
                    });
            }
        }
    };
        return {
            Init: self.func.init
        };
    })();

$(document).ready(function() {
    if ('direct-debit-form' === $('#direct-debit-form').data('feature')) {
        window.DirectDebitGuaranteeForm.Init();
    }
});
